import { useEffect, useState } from "react";
import { collection, onSnapshot, deleteDoc, doc } from "firebase/firestore";
import db from "../../firebase/firebase";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardText,
    Button
} from "reactstrap";
import { useNavigate } from 'react-router-dom';
import { addDoc } from "firebase/firestore";


export default function QuizList() {
    const [quizzes, setQuizzes] = useState([])
    const navigate = useNavigate()

    useEffect(() => {
        const unsub = onSnapshot(collection(db, "quizzes"), (snap) => {
            setQuizzes(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        });
        return unsub;
    }, []);

    const deleteQuiz = async (id) => {
        if (window.confirm("Delete this quiz?")) {
            await deleteDoc(doc(db, "quizzes", id))
        }
    }

    const onEdit = (quiz) => {
        navigate('/admin/add-quiz', { state: { quiz: quiz } })
    }

    return (
        <div className='main' style={{ display: 'flex', flex: 1, flexDirection: 'column', backgroundColor: '#f2f2f2' }}>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Quizzes
                </div>
            </div>
            <Button
                className='btn-block btn-dark'
                style={{ alignSelf: 'center', marginTop: 10, fontSize: 18, fontWeight: 'bold', width: '100%', backgroundColor: 'green', borderWidth: 0, height: 40, width: 300, alignSelf: 'center' }}
                onClick={() => onEdit(null)}>
                Add Quiz
            </Button>

            <div className="admin-quiz-grid">

                {quizzes.map((quiz) => (
                    <div key={quiz.id} className="admin-quiz-card">
                        <Card className="h-100">
                            <CardBody className="admin-quiz-card-body">
                                <CardTitle tag="h5">{quiz.title}</CardTitle>
                                <CardText className="text-muted">
                                    {quiz.description}
                                </CardText>
                                <CardText>
                                    <small>{quiz.questions?.length || 0} Questions</small>
                                </CardText>
                                <div className="d-flex gap-2">
                                    <Button size="sm" color="secondary" onClick={() => onEdit(quiz)}>
                                        Edit
                                    </Button>
                                    <Button size="sm" color="danger" onClick={() => deleteQuiz(quiz.id)}>
                                        Delete
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                ))}
            </div>
        </div>
    );
}

